/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './index.scss';
class quzhiCampus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            isDesktop: false,
        }
    }
    componentDidMount() {
        window.document.title = '趣智校园'
        if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
            this.setState({
                isMobile: true
            })
        } else {
            this.setState({
                isDesktop: true
            })
        }

        setTimeout(function () {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) === "micromessenger") {
                window.location.href = "weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index";
            }

            if (/Alipay/i.test(navigator.userAgent) || ua.indexOf('dingtalk') > -1) {
                window.location.href = "alipays://platformapi/startapp?appId=2018090661238647&page=pages/index/index"
            }

        }, 100)
    }
    render() {
        const openWeapp = (onBeforeJump) => {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.includes('micromessenger')) {
                window.location.href = "weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index"
            } else if (ua.includes('alipay') || ua.includes('dingtalk')) {
                window.location.href = "alipays://platformapi/startapp?appId=2018090661238647&page=pages/index/index"
            } else {
                alert('请在微信/支付宝内打开')
            }

        }
        return (
            <div className="page full">

                <div id="public-web-container" className={
                    this.state.isDesktop ? "hidden" : "full public-web-container"
                }>
                    <p className="">点击下方 “趣智校园” 打开洗浴饮水小程序</p>
                    <a id="public-web-jump-button" className="weui-btn weui-btn_primary weui-btn_loading"
                        onClick={openWeapp}>
                        趣智校园
                    </a>
                </div>
                <div id="desktop-web-container" className={
                    !this.state.isDesktop ? "hidden" : "full desktop-web-container"
                }>
                    <p className="">请在手机打开网页链接</p>
                </div>

            </div>
        )
    }
}
export default quzhiCampus;